import store from "@/store";

export class SocketControllers {
  uketsukeCd: string;
  yoyakuNo: string;
  socketPath: string;
  socket :any;

  workSubscription: any = null;
  removeWorkSubscription: any = null;
  workprogressSubscription: any = null;
  completeSubscription: any = null;
  recommendSubscription: any = null;
  inspectSeibiSubscribeQm: any = null;
  inspectSubscription: any = null;
  inspectItemSubscription: any = null;
  buhinSubscription: any = null;
  navSubscription: any = null;
  kensaHiyouSubscription: any = null;
  estimateListSubscription: any = null;
  youtoSubscription: any = null;
  mileageSubscription: any = null;
  memoSubscription: any = null;
  inspectSubscriptionDetail: any = null;
  questionnaireSubscription: any = null;
  timeSubscription: any = null;
  confirmationSubscription: any = null;
  frontSubscription: any = null;
  ak7Subscribe: any = null;
  jizenRecommendSubscribe: any = null;
  inspectionsSubscribe: any = null;
  inspectSeibiSubscribe: any = null;
  shouhiyouSubscription: any = null;
  optionSubscription: any = null;
  couponSubscription: any = null;
  jizenDisplayOrderSubscription: any = null;
  shohiyouSubscription: any = null;

  constructor() {
    this.uketsukeCd = store.getters["ReservationDetail/uketsukeCd"];
    this.yoyakuNo = store.getters["ReservationDetail/yoyakuNo"];
    this.socket = store.getters["Socket/socket"];
  }

  //
  setsocket(socketPath:string){
      this.socketPath = socketPath;
  }
  
  //ソケット通信開始処理
  //Vue側で行うときは
  //import { StompClient } from "@/service/StompClient";
  //して
  //@Action("connect", { namespace: "Socket" })
  //connectSocket: any;
  //@Getter("socket", { namespace: "Socket" })
  //socket: StompClient;
  //してから
  //this.connectSocket(this.onConnect);
  //する
  connectSocket(any:any){
    //this.socket.connect(any);
    store.dispatch("Socket/connect", any);
  }

  checkSocket(){
    return this.socket.isConnected();
  }

  /*各種ソケットの作成 */
  //PutMapping("/inspections") updateInspectsSeibi()他
  socketWorkCompleted(collback:any){
    if (!this.workSubscription) {
      this.workSubscription = this.socket.client.subscribe(
        `/connect/factory/work-order/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }
  
  /* 2024-03-21 牧 衝突調整 [START]*/
  ////PutMapping("/inspections") updateInspectsSeibi()他
  //socketWorkRemoved(collback:any){
  //  if (!this.removeWorkSubscription) {
  //    this.removeWorkSubscription = this.socket.client.subscribe(
  //      `/connect/factory/work-order/${this.uketsukeCd}${this.yoyakuNo}/removed`,
  //      collback
  //    );
  //  }
  //}
  /* 2024-03-21 牧 衝突調整 [END]*/

  //updateWorkProgressState()
  //PutMapping("/workprogress") updateSknWorkProgressState()
  socketWorkProgress(collback:any){
    if (!this.workprogressSubscription) {
      this.workprogressSubscription = this.socket.client.subscribe(
        `/connect/workprogress/${this.uketsukeCd}${this.yoyakuNo}`,
        collback
      );
    }
  }

  //工場側での検査終了実行 ->
  //shaken\src\components\EstimateSubHeader.vue
  //shaken\src\components\SubHeader.vue
  socketCompleted(collback:any){
    if (!this.completeSubscription) {
      this.completeSubscription = this.socket.client.subscribe(
        `/connect/completed/${this.uketsukeCd}${this.yoyakuNo}`,
        collback
      );
    }
  }

  //車検コース変更 ->
  //shaken\src\page\factory\inspectionSelections.vue
  //shaken\src\page\factory\recMaintenance.vue
  socketInspectionsBase(collback:any){
    if (!this.recommendSubscription) {
      this.recommendSubscription = this.socket.client.subscribe(
        `/connect/inspections/${this.uketsukeCd}${this.yoyakuNo}/reload`,
        collback
      );
    }
  }

  //1個所
  //getQmMitsumoriPreview(
  //PutMapping("/recommend-inspect-seibi-qm") updateRecommendInspectSeibiQM()
  socketInspectQm(collback:any){
    if (!this.inspectSeibiSubscribeQm) {
      this.inspectSeibiSubscribeQm = this.socket.client.subscribe(
        `/connect/inspect-seibi-qm/${this.socketPath}/completed`,
        collback
      );
    }
  }

  //saveInspectLineSeibi(data: any) {
  //PutMapping("/inspect-line-seibi") updateGensha()他
  socketInspect(collback:any){
    if (!this.inspectSubscription) {
      this.inspectSubscription = this.socket.client.subscribe(
        `/connect/inspect/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }

  //savePartSelection(data: any) {
  //PutMapping("/part-selection") updatePartsSelections()他
  socketInspectItem(collback:any){
    if (!this.inspectItemSubscription) {
      this.inspectItemSubscription = this.socket.client.subscribe(
        `/connect/inspect-item/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }

  //savePartSelection(data: any) {
  //PutMapping("/part-selection") updatePartsSelections()他
  socketInspectBuhinChange(collback:any){
    if (!this.buhinSubscription) {
      this.buhinSubscription = this.socket.client.subscribe(
        `/connect/inspect-buhin-change/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }
  
  //各所 -> 車検状況の更新
  socketExtends(collback:any){
    if (!this.timeSubscription) {
      this.timeSubscription = this.socket.client.subscribe(
        `/connect/extends/${this.uketsukeCd}${this.yoyakuNo}/inspect-time`,
        collback
      );
    }
  }

  //saveInspectLineResult(data: any) {
  //PostMapping("/inspect-line") saveInspectLines()他
  socketCustomerNavigations(collback:any){
    if (!this.navSubscription) {
      this.navSubscription = this.socket.client.subscribe(
        `/connect/customer/navigations/${this.uketsukeCd}${this.yoyakuNo}`,
        collback
      );
    }
  }

  //updateKensaHiyou(data: any) {??????
  //PostMapping("/kensaHiyou") updateKensaHiyou()
  socketCustomerKensaHiyou(collback:any){
    if (!this.kensaHiyouSubscription) {
      this.kensaHiyouSubscription = this.socket.client.subscribe(
        `/connect/customer/kensaHiyou/${this.uketsukeCd}${this.yoyakuNo}/reload`,
        collback
      );
    }
  }

  //部品代を更新したときの情報伝播 -> 各所
  socketCustomerEditPrice(collback:any){
    if (!this.estimateListSubscription) {
      this.estimateListSubscription = this.socket.client.subscribe(
        `/connect/customer/edit-price/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }

  //getQuestionnaireList(uketsukeExtendsId: number) { //AK-0001
  //PutMapping("questionnaire-extreme") updateQuestionnaireExtreme()
  socketQuestionnaireExtreme(collback:any){
    if (!this.questionnaireSubscription) {
      this.questionnaireSubscription = this.socket.client.subscribe(
        `/connect/customer/questionnaire-extreme/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }

  //saveOmonaYouto(data: CustomerParams) {
  //PutMapping("reservations/omona-youto") updateOmonaYouto()
  socketCustomerYouto(collback:any){
    if (!this.youtoSubscription) {
      this.youtoSubscription = this.socket.client.subscribe(
        `/connect/customer/reservation/${this.uketsukeCd}${this.yoyakuNo}/omona-youto`,
        collback
      );
    }
  }

  //saveConfirmation(param: ConfirmationBeforeEntry) {
  //PutMapping("reservations/confirmation-before-entries") reservationConfirmation()
  socketConfirmation(collback:any){
    if (!this.confirmationSubscription) {
      this.confirmationSubscription = this.socket.client.subscribe(
        `/connect/customer/reservation/${this.uketsukeCd}${this.yoyakuNo}/confirmation-before-entry`,
        collback
      );
    }
  }

  //saveMileage(data: CustomerParams) {
  //PutMapping("reservations/soukoukm") updateSoukouKm()
  socketReservation(collback:any){
    if (!this.mileageSubscription) {
      this.mileageSubscription = this.socket.client.subscribe(
        `/connect/reservation/${this.uketsukeCd}${this.yoyakuNo}/soukoukm`,
        collback
      );
    }
  }

  //車検メモ編集保存 -> 車検前画面
  socketReservationConfirmation(collback:any){
    if (!this.memoSubscription) {
      this.memoSubscription = this.socket.client.subscribe(
        `/connect/reservation/${this.uketsukeCd}${this.yoyakuNo}/sknmemo`,
        collback
      );
    }
  }

 //saveInsectionDetail(inspectionDetail: InspectDetail) {
  //PutMapping("/inspection-detail-selection") updateInspectionDetailSelection()
  socketReservationInspection(collback:any){
    if (!this.inspectSubscriptionDetail) {
      this.inspectSubscriptionDetail = this.socket.client.subscribe(
        `/connect/reservation/${this.uketsukeCd}${this.yoyakuNo}/inspectionDetailCompleted`,
        collback
      );
    }
  }

  //saveFrontTantousha(data: CustomerParams) {
  //PutMapping("reservations/front-tantousha") updateFrontTantousha()
  socketFront(collback:any){
    if (!this.frontSubscription) {
      this.frontSubscription = this.socket.client.subscribe(
        `/connect/reservation/${this.uketsukeCd}${this.yoyakuNo}/front-tantousha`,
        collback
      );
    }
  }

  //getPayment(sknUketsukeExtendsId: number) {???
  //PostMapping("/payments") savePayment()
  socketPayments(collback:any){
    if (!this.ak7Subscribe) {
      this.ak7Subscribe = this.socket.client.subscribe(
        `/connect/payments/${this.uketsukeCd}${this.yoyakuNo}`,
        collback
      );
    }
  }

  //saveJizenRecommend(data: any) {
  //PutMapping("/jizen-recommend") updateJizenRecommend() 他
  socketJizenRecommend(collback:any){
    if (!this.jizenRecommendSubscribe) {
      this.jizenRecommendSubscribe = this.socket.client.subscribe(
        `/connect/jizen-recommend/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }

  //updateDoTenken(
  //PutMapping("/inspections") updateInspectsSeibi()
  socketInspections(collback:any){
    if (!this.inspectionsSubscribe) {
      this.inspectionsSubscribe = this.socket.client.subscribe(
        `/connect/customer/inspections/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }

  //savePartSelection(data: any) {
  //PutMapping("/part-selection") updatePartsSelections()他
  socketInspectSeibi(collback:any){
    if (!this.inspectSeibiSubscribe) {
      this.inspectSeibiSubscribe = this.socket.client.subscribe(
        `/connect/inspect-seibi/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }

  //saveOption(data: any) {???/
  //PostMapping("/option") saveOption()
  socketOption(collback:any){
    if (!this.optionSubscription) {
      this.optionSubscription = this.socket.client.subscribe(
        `/connect/customer/option/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }

  //saveCoupon(data: any) {????
  //PostMapping("/coupon") saveCoupon()
  socketCoupon(collback:any){
    if (!this.couponSubscription) {
      this.couponSubscription = this.socket.client.subscribe(
        `/connect/customer/coupon/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }

  //saveJizenDisplayOrder(id: any, data: any) {
  //PutMapping("/jizen-display-order/{sknUketsukeExtendsId}") updateJizenDisplayOrder()
  socketJizenDisplayOrder(collback:any){
    if (!this.jizenDisplayOrderSubscription) {
      this.jizenDisplayOrderSubscription = this.socket.client.subscribe(
        `/connect/jizen-display-order/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }

  //saveShohiyou(data: any) {???
  //PostMapping("/shohiyou") saveShohiyou()
  socketShohiyouCompleted(collback:any){
    if (!this.shouhiyouSubscription) {
      this.shouhiyouSubscription = this.socket.client.subscribe(
        `/connect/customer/shohiyou/${this.uketsukeCd}${this.yoyakuNo}/completed`,
        collback
      );
    }
  }

  //updateShakenShurui(inspectionDetail: InspectDetail) {
  //PutMapping("/update-shaken-shurui") updateShakenShurui()
  socketShohiyouReload(collback:any){
    if (!this.shohiyouSubscription) {
      this.shohiyouSubscription = this.socket.client.subscribe(
        `/connect/customer/shohiyou/${this.uketsukeCd}${this.yoyakuNo}/reload`,
        collback
      );
    }
  }

  /* 終了時ソケット解放 */
  freeSocketResources(){
    if (this.workSubscription) {
      this.workSubscription.unsubscribe();
    }
    if (this.removeWorkSubscription) {
      this.removeWorkSubscription.unsubscribe();
    }
    if (this.completeSubscription) {
      this.completeSubscription.unsubscribe();
    }
    if (this.workprogressSubscription) {
      this.workprogressSubscription.unsubscribe();
    }
    if (this.recommendSubscription) {
      this.recommendSubscription.unsubscribe();
    }
    if (this.inspectSeibiSubscribeQm) {
      this.inspectSeibiSubscribeQm.unsubscribe();
    }
    if (this.inspectSubscription) {
      this.inspectSubscription.unsubscribe();
    }
    if (this.inspectItemSubscription) {
      this.inspectItemSubscription.unsubscribe();
    }
    if (this.navSubscription) {
      this.navSubscription.unsubscribe();
    }
    if (this.buhinSubscription) {
      this.buhinSubscription.unsubscribe();
    }
    if (this.kensaHiyouSubscription) {
      this.kensaHiyouSubscription.unsubscribe();
    }
    if (this.estimateListSubscription) {
      this.estimateListSubscription.unsubscribe();
    }
    if (this.youtoSubscription) {
      this.youtoSubscription.unsubscribe();
    }
    if (this.mileageSubscription) {
      this.mileageSubscription.unsubscribe();
    }
    if (this.memoSubscription) {
      this.memoSubscription.unsubscribe();
    }
    if (this.inspectSubscriptionDetail) {
      this.inspectSubscriptionDetail.unsubscribe();
    }
    if (this.questionnaireSubscription) {
      this.questionnaireSubscription.unsubscribe();
    }
    if (this.timeSubscription) {
      this.timeSubscription.unsubscribe();
    }
    if (this.confirmationSubscription) {
      this.confirmationSubscription.unsubscribe();
    }
    if (this.frontSubscription) {
      this.frontSubscription.unsubscribe();
    }
    if (this.ak7Subscribe) {
      this.ak7Subscribe.unsubscribe();
    }
    if (this.jizenRecommendSubscribe) {
      this.jizenRecommendSubscribe.unsubscribe();
    }
    if (this.inspectionsSubscribe) {
      this.inspectionsSubscribe.unsubscribe();
    }
    if (this.inspectSeibiSubscribe) {
      this.inspectSeibiSubscribe.unsubscribe();
    }
    if (this.shouhiyouSubscription) {
      this.shouhiyouSubscription.unsubscribe();
    }
    if (this.optionSubscription) {
      this.optionSubscription.unsubscribe();
    }
    if (this.couponSubscription) {
      this.couponSubscription.unsubscribe();
    }
    if (this.jizenDisplayOrderSubscription) {
      this.jizenDisplayOrderSubscription.unsubscribe();
    }
    if (this.shohiyouSubscription) {
      this.shohiyouSubscription.unsubscribe();
    }
  }
  
}